import "./Sponsors.module.css";
import Header from "@/reusable_sections/Header";
import SponsorGallery from "./sections/SponsorGallery";
import BecomeASponsor from "./sections/BecomeASponsor";
import Footer from "@/reusable_sections/Footer";
export default function SponsorsPage() {
  return <div>
      <Header />
      <SponsorGallery />
      <BecomeASponsor />
      <Footer />
    </div>;
}